import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { Dimensions } from '../../models/dimensions.type';
import { Title } from '../../models/config/chart.config';

@Component({
    selector: '[aaTitle]',
    templateUrl: './title.component.html',
    styleUrls: [
        './title.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TitleComponent implements OnInit, OnChanges
{
    private posX: number;
    private posY: number;
    @Input() title: Title;
    @Input() dimensions: Dimensions;
    @Input() position: string;
    transform: string;
    textAnchor: string;

    constructor() { }

    ngOnInit ()
    {
        this.update();
    }

    ngOnChanges (changes: SimpleChanges): void
    {
        this.update();
    }

    private update ()
    {
        this.horizPos('left');
        this.vertiPos('top');
        this.transform = `translate(${this.posX}px, ${this.posY}px)`;
    }

    private horizPos (align: string): void
    {
        switch (align)
        {
            case 'left':
                this.textAnchor = 'start';
                this.posX = -1 * this.dimensions.marginLeft;
                break;

            case 'right':
                this.textAnchor = 'end';
                this.posX = this.dimensions.width - this.dimensions.marginLeft;
                break;

            case 'center':
            default:
                this.textAnchor = 'middle';
                this.posX = this.dimensions.width / 2 - this.dimensions.marginLeft;
                break;
        }
    }

    private vertiPos (align: string): void
    {
        switch (align)
        {
            case 'bottom':
                this.posY = this.dimensions.height - (2 / 3) * this.dimensions.marginBottom;
                break;

            case 'top':
            default:
                this.posY = (-1 / 3) * this.dimensions.marginTop;
                break;
        }
    }
}
